import { Component, ViewChild, OnInit, inject, CUSTOM_ELEMENTS_SCHEMA, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { WindowService } from 'src/shared/providers/window.service';

import { Util } from 'src/shared/util/util';

import { PropertyDepositsService, PropertyDeposit } from 'src/shared/services/property-deposits.service';

import { TidyUiComponentsModule } from 'src/tidy-ui-components/tidy-ui-components.module';
import { SharedModule } from 'src/shared/shared.module';

@Component({
  selector: 'deposits-content',
  templateUrl: './deposits-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    IonicModule,
    TidyUiComponentsModule,
    SharedModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DepositsContentComponent implements OnInit {
  private cdr = inject(ChangeDetectorRef);
  private propertyDepositsService = inject(PropertyDepositsService);
  private util = inject(Util);

  readonly windowService = inject(WindowService);

  deposits: PropertyDeposit[] = [];
  headers: string[] = [];
  rows: any[] = [];
  isDataLoaded = false;
  errorMessage: string;
  @ViewChild('tidyTable') tidyTable: any;

  async ngOnInit() {
    try {
      await this.loadPage();
    } catch (err) {
      this.errorMessage = err?.error?.message || err?.message || 'Failed to load deposits';
      this.util.showError(this.errorMessage, 10000);
    }
  }

  async loadPage() {
    this.buildHeaders();
    try {
      this.deposits = await this.propertyDepositsService.getPropertyDeposits();
    } catch {
      this.deposits = [];
    }
    this.buildRows(this.deposits);
    this.isDataLoaded = true;
    this.cdr.markForCheck();
  }

  buildHeaders(): void {
    this.headers = [
      'Property',
      'Guest',
      'Type',
      'Amount',
      'Status',
      'Claim',
      'Channel',
      'last-column'
    ];
  }

  buildRows(deposits: PropertyDeposit[]): void {
    this.rows = deposits.map(deposit => ({
      id: deposit.id,
      'Property': {
        value: deposit.property_name || 'Unknown Property',
        action: null,
      },
      'Guest': {
        value: deposit.guest_name || '',
        action: null,
      },
      'Type': {
        value: deposit.deposit_type || '',
        action: null,
      },
      'Amount': {
        value: deposit.amount !== null ? `$${deposit.amount.toLocaleString('en-US')}` : '',
        action: null,
      },
      'Status': {
        value: deposit.status || '',
        action: null,
      },
      'Claim': {
        value: deposit.claim_amount > 0 ? `$${deposit.claim_amount.toLocaleString('en-US')}` : '—',
        action: null,
      },
      'Channel': {
        value: deposit.channel || '',
        action: null,
      },
      'last-column': {
        value: deposit.id,
        action: null,
        hasChevron: true,
      },
    }));
  }

  sortChanged(sort: any): void {
    this.rows.sort((a, b) => {
      const valA = a[sort.active]?.value || '';
      const valB = b[sort.active]?.value || '';

      if (sort.active === 'Amount' || sort.active === 'Claim') {
        const numA = parseFloat(String(valA).replace(/[$,—]/g, '')) || 0;
        const numB = parseFloat(String(valB).replace(/[$,—]/g, '')) || 0;
        return sort.direction === 'asc' ? numA - numB : numB - numA;
      }

      const strA = String(valA).toLowerCase();
      const strB = String(valB).toLowerCase();
      if (strA < strB) {return sort.direction === 'asc' || sort.direction === '' ? -1 : 1;}
      if (strA > strB) {return sort.direction === 'asc' || sort.direction === '' ? 1 : -1;}
      return 0;
    });
  }

  onTableColumnClick(event: any): void {
    const foundDeposit = this.deposits.find(d => d.id === event.element.id);
    if (!foundDeposit) {return;}
  }

  getEmptyStateMessage(): string {
    return 'No deposits tracked. Security deposits, pet deposits, and damage claims will appear here as reservations are booked.';
  }
}
